import type { IamApi } from '@/features/iam/api/iam-api'
import { Id } from '@/infra/id'
import { FeatureToggles } from '@/features/feature-toggles'

export class MagicLinkStore {
  constructor(private readonly _api: IamApi) {}

  /**
   * Requests a magic link for the specified email address and workspace ID.
   */
  async request(workspaceId: Id, email: string): Promise<void> {
    if (FeatureToggles.magicLinkV4()) {
      return this._api.magicLinksV4.requestMagicLink({
        workspace_id: Id.assert(workspaceId),
        email,
      })
    }
    return this._api.magicLinks.request(workspaceId, email)
  }
}
